import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import discord_notification from "../../images/discord_notification.png"
import start_page_view from "../../images/start_page_view.png"
import demo_page_view from "../../images/demo_page_view.png"

export default function Slider() {
  return (
    <section className="lp-section lp-demo-slider" data-aos="fade-up" data-aos-delay="80">
      <h2 className="lp-slider-title">Jak to wygląda w praktyce?</h2>
      <Swiper
        modules={[Autoplay, Pagination]}
        autoplay={{ delay: 3500, disableOnInteraction: false }}
        pagination={{ clickable: true }}
        loop
        spaceBetween={30}
        className="lp-swiper"
      >
        <SwiperSlide>
          <div className="lp-slider-img-wrap">
            <img
              src={discord_notification}
              alt="Powiadomienie Discord ML Strategy"
              className="lp-slider-img"
              loading="lazy"
            />
            <div className="lp-slider-caption">Powiadomienia Discord – otrzymujesz natychmiast po transakcji</div>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="lp-slider-img-wrap">
            <img
              src={start_page_view}
              alt="Panel strategii ML - demo"
              className="lp-slider-img"
              loading="lazy"
            />
            <div className="lp-slider-caption">Twój panel strategii ML – monitoring inwestycji 24/7</div>
          </div>
        </SwiperSlide>
        <SwiperSlide>
  <div className="lp-slider-img-wrap">
    <img
      src={demo_page_view}
      alt="Panel demo strategii ML"
      className="lp-slider-img"
      loading="lazy"
    />
    <div className="lp-slider-caption" style={{ color: "#ffc146" }}>
      Tryb demo - testuj strategie bez ryzyka
    </div>
  </div>
</SwiperSlide>
      </Swiper>
    </section>
  );
}
